export default __webpack_public_path__ + "static/media/Oak Seed.44f4c1b6.PNG";